export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10328.3074b5e0.jpg";